import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { InterimBalanceSheet, InterimBalanceSheetForm } from "./interimBalanceSheetDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<InterimBalanceSheet>,
  data?: InterimBalanceSheet,
): InterimBalanceSheetForm {
  return new InterimBalanceSheetForm(dispatch, context, data);
}

export function applyForm(form: InterimBalanceSheetForm): InterimBalanceSheet {
  return {
    type: DecisionType.interimBalanceSheet,
    balanceSheetDate: form.balanceSheetDate.validatedValue,
    hasAuditor: form.hasAuditor,
    balanceSheetAttachmentId: form.balanceSheet.attachment?.id,
    auditorConfirmationAttachmentId: form.auditorConfirmation.attachment?.id,
  };
}

export function validate(form: InterimBalanceSheetForm) {
  return form.validate();
}

export function isValid(form: InterimBalanceSheetForm) {
  return form.isValid;
}

export const interimBalanceSheetHandler: DecisionTypeHandler<
  DecisionType.interimBalanceSheet,
  InterimBalanceSheet,
  InterimBalanceSheetForm
> = {
  type: DecisionType.interimBalanceSheet,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
